import React from 'react'
import { deepCopy, randomReactKey } from '../../utilities'
import { Tooltip } from 'react-tooltip'

// Tranlations
import t from '../../translations'

export const onDragStart = (event) => {
    event.stopPropagation()

    const target = event.target.closest('.dragItem')
    const itemFrom = +target.getAttribute('data-element-index')
    let groupFrom = +target.closest('.dragGroup').getAttribute('data-element-index')
    const html = target.outerHTML

    event.dataTransfer.setDragImage(document.querySelector(`img[data-img-id='${groupFrom}-${itemFrom}']`), 10, 10);

    const isCategory = groupFrom === -1
    if(groupFrom === -1){
        groupFrom = 0
    }

    localStorage.setItem('dragFrom', JSON.stringify({
        isCategory,
        groupFrom,
        itemFrom,
        'text/html': html,
    }))
}

export const onDragOver=(event) => {
    const dragData = JSON.parse(localStorage.getItem('dragFrom'))

    const dropzoneIndex = +event.target.getAttribute('data-element-index')
    let dropzoneGroupIndex = +event.target.closest('.dragGroup').getAttribute('data-element-index')
    const groupFrom = dragData.groupFrom
    const itemFrom = dragData.itemFrom

    if(dropzoneGroupIndex === -1){
        dropzoneGroupIndex = 0
    }

    // Do not show dropzone if it's a sibling of the dragged element
    const drozoneIsSibling = dropzoneGroupIndex === groupFrom && (dropzoneIndex === itemFrom || dropzoneIndex === itemFrom + 1)
    if(!drozoneIsSibling){
        event.stopPropagation()
        event.preventDefault()

        document.querySelector('.draggedOver')?.classList.remove('draggedOver')
        event.target.classList.add('draggedOver')
        event.target.classList.add('overDropzone')
    }
}

export const onDragLeave = (event) => event.target.classList.remove('overDropzone')

export const onDrop = (event, reorderGroups) => {
    event.stopPropagation()
    event.preventDefault()

    const dragInfo = JSON.parse(localStorage.getItem('dragFrom'))

    event.target.innerHTML = dragInfo['text/htnl']
    event.target.classList.remove('draggedOver')
    event.target.classList.remove('empty')
    event.target.classList.add('dropped')

    let groupFrom = dragInfo.groupFrom
    const itemFrom = dragInfo.itemFrom
    const groupTo = +event.target.closest('.dragGroup').getAttribute('data-element-index')
    const dropzoneTo = +event.target.getAttribute('data-element-index')

    if(dragInfo.isCategory){
        groupFrom = -1
    }

    localStorage.setItem('dragTo', JSON.stringify({groupTo, itemTo: dropzoneTo}))
    
    reorderGroups(groupFrom, itemFrom, groupTo, dropzoneTo)
}

export const onDragEnd = () => {
    setTimeout(() => {
        const draggedOverEl = document.querySelector('.draggedOver')

        if(draggedOverEl && !draggedOverEl.classList.contains('overDropzone')){
            draggedOverEl.classList.remove('draggedOver')
        }
    }, 10)
}

export const addItemToArray = (arr, groupFrom, itemFrom, groupTo, dropzoneTo) => {
    let arrCopy = deepCopy(arr)

    // Category reordering
    if(groupFrom === -1 && groupTo === -1){
        const categoryCopy = deepCopy(arr[itemFrom])

        arrCopy.splice(itemFrom, 1)
        if(dropzoneTo === 0){
            dropzoneTo = 1
        }
        arrCopy.splice(dropzoneTo -1, 0, categoryCopy)

        return arrCopy
    }

    // Item reordering
    let itemCopy = deepCopy(arr[groupFrom].items[itemFrom])
    const mustIncrement = groupFrom === groupTo && itemFrom > dropzoneTo

    // Add
    let arrCopyAdd = deepCopy(arrCopy)
    const arrCopyAddLength = arrCopyAdd[groupTo].items.length

    if(dropzoneTo > 0 && dropzoneTo < arrCopyAddLength){
        const start = arrCopyAdd[groupTo].items.slice(0, dropzoneTo)
        const end = arrCopyAdd[groupTo].items.slice(dropzoneTo)
        arrCopyAdd[groupTo].items = [...start, itemCopy, ...end]
    }
    if(dropzoneTo === 0){
        arrCopyAdd[groupTo].items.unshift(itemCopy)
    }
    if(dropzoneTo === arrCopyAddLength && arrCopyAddLength !== 0){
        arrCopyAdd[groupTo].items.push(itemCopy)
    }

    // If same group and moving item up
    if(mustIncrement){
        itemFrom++
    }

    // Remove
    let arrCopyRemove = deepCopy(arrCopyAdd)
    const arrCopyRemoveLength = arrCopyRemove[groupFrom].items.length
    if(itemFrom > 0 && itemFrom < arrCopyRemoveLength){
        const start = arrCopyRemove[groupFrom].items.slice(0, itemFrom)
        const end = arrCopyRemove[groupFrom].items.slice(itemFrom + 1)
        arrCopyRemove[groupFrom].items = [...start, ...end]
    }
    if(itemFrom === 0){
        arrCopyRemove[groupFrom].items.shift()
    }
    if(itemFrom === arrCopyRemoveLength){
        arrCopyRemove[groupFrom].items.pop()
    }
    
    arrCopy[groupTo].items = arrCopyAdd[groupTo].items
    arrCopy[groupFrom].items = arrCopyRemove[groupFrom].items

    return arrCopy
}

const DragContainer = (props) => {
    const groups = props.formattedGroups.map((group, groupIndex) => {
        const categoryName = group.categoryName

        return <div key={randomReactKey()} >
            <div className='dragCategory'>
                <div>{categoryName}</div>
                <div className={`addItem ${props.isHistoryDate ? 'disabled' : ''}`}>
                    <Tooltip id='add-todo-item'/>
                    <box-icon
                        type='regular'
                        name='plus'
                        color='white'
                        data-tooltip-id='add-todo-item'
                        data-tooltip-content={props.isEditingGroups ? t[props.lang]['Add category'] : t[props.lang]['Add item']}
                        data-tooltip-place='left'
                        onClick={(event) => {
                            if(props.isHistoryDate){
                                return
                            }
                            localStorage.setItem('dragTo',JSON.stringify({itemFrom: -1, groupFrom: props.isEditingGroups ? -1 : groupIndex}))
                            props.setCurrentDataIndexes([groupIndex])
                            props.setSubPage('addItem')
                            props.setNewTextValue('')
                            props.setIsAddingCategory()
                        }}
                    />
                </div>
            </div>

            <div
                className='dragContainer'
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
            >
                {group.items}
            </div>
        </div>
    })
    
    // TODO: Make this "disabled" class more robust
    return <div className={`Draggable ${props.disabled ? 'disabled' : ''}`}>
        {!props.isEditingGroups && <div className='dragContainerButtons'>
            {props.showCalendar ? <div className='calendar'>
                <Tooltip id='history-calendar'/>
                    <box-icon
                        type='regular'
                        name='calendar'
                        color='#777777' // $darkGrey1
                        data-tooltip-id='history-calendar'
                        data-tooltip-content={t[props.lang]['History']}
                        data-tooltip-place='right'
                        onClick={() => {
                            props.setSubPage('calendar')
                        }}
                    />
                </div> : <div></div>}
            <div className={`manageCategory ${props.isHistoryDate ? 'disabled' : ''}`}>
                <Tooltip id='manage-category'/>
                <box-icon
                    type='regular'
                    name='category'
                    color='#777777' // $darkGrey1
                    data-tooltip-id='manage-category'
                    data-tooltip-content={t[props.lang]['Manage categories']}
                    data-tooltip-place='left'
                    onClick={() => {
                        if(props.isHistoryDate){
                            return
                        }
                        props?.setCurrentDataIndexes([])
                        props?.setSubPage('manageGroups')
                    }}
                />
            </div>
        </div>}         
        {groups}
    </div>
}

export default DragContainer